export default function SvgSad() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enableBackground="new 0 0 48 48"
        viewBox="0 0 48 48"
        width="30px"
        cursor="pointer"
      >
        <g>
          <path
            fill="#5791FF"
            d="M30.507 28.682s-1.134 1.375-1.602 2.328-.832 2.32-.507 3.253 1.272 1.78 2.176 1.752c.905-.028 2.29-.862 2.473-2.501s-1.363-3.622-1.777-4.001-.763-.83-.763-.83z"
          ></path>
          <path
            fill="#FFD872"
            d="M36.245 24c0 3.27-1.28 6.24-3.37 8.43-.09-.5-.28-.99-.58-1.42l-1.69-2.47-1.7 2.47c-.79 1.15-.88 2.69-.1 3.83.08.11.16.22.25.31-1.54.7-3.25 1.09-5.05 1.09-6.77 0-12.25-5.48-12.25-12.24s5.48-12.24 12.25-12.24c6.76 0 12.24 5.48 12.24 12.24z"
          ></path>
          <path
            fill="none"
            stroke="#303030"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
            d="M36.245 24c0 3.27-1.28 6.24-3.37 8.43-.09-.5-.28-.99-.58-1.42l-1.69-2.47-1.7 2.47c-.79 1.15-.88 2.69-.1 3.83.08.11.16.22.25.31-1.54.7-3.25 1.09-5.05 1.09-6.77 0-12.25-5.48-12.25-12.24s5.48-12.24 12.25-12.24c6.76 0 12.24 5.48 12.24 12.24zM32.875 32.43c.16.83.01 1.7-.48 2.41-.46.67-1.09 1.09-1.79 1.09-.58 0-1.12-.29-1.55-.78"
          ></path>
          <ellipse
            cx="18.557"
            cy="22.86"
            fill="#303030"
            rx="1.249"
            ry="1.501"
          ></ellipse>
          <ellipse
            cx="18.557"
            cy="22.86"
            fill="#303030"
            rx="1.249"
            ry="1.501"
          ></ellipse>
          <path
            fill="none"
            stroke="#303030"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
            d="M18.948 18.84s-2.053-.684-2.737 1.76"
          ></path>
          <ellipse
            cx="29.444"
            cy="22.86"
            fill="#303030"
            rx="1.249"
            ry="1.501"
          ></ellipse>
          <ellipse
            cx="29.444"
            cy="22.86"
            fill="#303030"
            rx="1.249"
            ry="1.501"
          ></ellipse>
          <path
            fill="none"
            stroke="#303030"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
            d="M29.053 18.84s2.052-.684 2.736 1.76M20.552 29.378c2.483-2.02 4.804-1.984 6.966 0"
          ></path>
        </g>
      </svg>
    </>
  );
}
